import { CSSProperties, ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { isString, parseString } from 'coreOld/utils';

interface IProps {
  text: string | JSX.Element;
  fontSize?: number;
  isSubText?: boolean;
  italic?: boolean;
  bold?: boolean;
  upperCase?: boolean;
  textEllipsis?: boolean;
  style?: CSSProperties;
}

type WrapperProps = {
  fontSize?: number;
  isSubText?: boolean;
  italic?: boolean;
  bold?: boolean;
  upperCase?: boolean;
  textEllipsis?: boolean;
  style?: CSSProperties;
  children?: ReactNode;
};

const Wrapper = styled.div<WrapperProps>`
  font-weight: 400;
  display: block;
  color: inherit;

  ${({ textEllipsis }) =>
    textEllipsis &&
    css`
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: inherit;
    `}

  ${({ fontSize }) =>
    fontSize &&
    css`
      font-size: ${fontSize}px;
    `}

  ${({ italic }) =>
    italic &&
    css`
      font-style: italic;
    `}

  ${({ bold }) =>
    bold &&
    css`
      font-weight: 600;
    `}

  ${({ isSubText }) =>
    isSubText &&
    css`
      font-size: 10px;
    `}

  ${({ upperCase }) =>
    upperCase &&
    css`
      text-transform: uppercase;
    `}

  ${({ style }) => (style ? css(style as any) : undefined)}
`;

/** @deprecated */
const TextLine = ({
  text,
  fontSize,
  isSubText,
  bold,
  italic,
  upperCase,
  textEllipsis,
  style,
}: IProps) => {
  return (
    <Wrapper
      fontSize={fontSize}
      isSubText={isSubText}
      bold={bold}
      italic={italic}
      upperCase={upperCase}
      textEllipsis={textEllipsis}
      style={style}
    >
      {isString(text) ? parseString(text as string) : text}
    </Wrapper>
  );
};

export default TextLine;
